export { type LatestWebSocketChannel as WebSocketChannel } from "../orpc-client/api/contract-latest.js";
